module.exports = {
	"name": "G.G. Brown Laboratory (GGBL)",
	"bathroomrating": [],
	"tips": [
		{
			"text": "Many of the side hallways have little 2-3 person study rooms that are good for individual or small group work.",
			"person": "Nick Kortman"
		}
	],
	"address": "2350 Hayward St. Ann Arbor, MI",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151210/rom.FEA_.GiantRubicsCube.12.10.15.050.jpg?itok=YE40yLRd",
			"caption": "Engineering graduate student Martin Harris demonstrates how his team's giant Rubik's cube works in the GG Brown Building on Thursday. The cube could possibly be named the world's largest Rubik’s cube that is solvable under human power.",
			"author": "Ryan McLoughlin"
		}
	],
	"position": {
		"lat": 42.293299,
		"lng": -83.713832
	},
	"catImage": "bluestar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"academics": 1,
		"universitybuilding": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ggbrown.json
// module id = 883
// module chunks = 0